// This file defines constants for shape names as defined internally to this project
// e.g. for saying 'This button draws a circle'.
// These are not the same as OpenLayers geometry types, though there is overlap.
// See src/client/utils/constants/geometryType.js for the OpenLayers geometry types

export const CIRCLE = 'Circle';
export const SQUARE = 'Square';
export const TRIANGLE = 'Triangle';
export const ICON = 'Icon';
export const BOX = 'Box';
export const POLYGON = 'Polygon';
export const LINE = 'LineString';

export default { CIRCLE, SQUARE, TRIANGLE, ICON, BOX, POLYGON, LINE };
